import { render, staticRenderFns } from "./ActiveModal.vue?vue&type=template&id=4c127e86"
import script from "./ActiveModal.vue?vue&type=script&lang=js"
export * from "./ActiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports